import { render, staticRenderFns } from "./DrinkList.vue?vue&type=template&id=208fc8df"
import script from "./DrinkList.vue?vue&type=script&lang=js"
export * from "./DrinkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports